export const PICK_UP_TIME = "Pick-up time";
export const DROP_OFF_TIME = "Drop-off time";
export const DRIVER_AGE = "Driver age";
export const SEARCH_RENTAL_CARS = "Search Rental Cars";
